import React from "react";
import useAuth from "../hooks/useAuth";

/**
 * Show `children` only to someone allowed to use them.
 *
 *   <AuthorizedContent feature="savings" action="add">…</AuthorizedContent>
 *   <AuthorizedContent superAdmin>…</AuthorizedContent>
 *
 * By permission, from the server's answer for the fund that is open — the same
 * rule the server applies when the button is pressed. It used to take a list
 * of role names, which drifted from what the roles may actually do.
 */
function AuthorizedContent({ children, feature, action = "view", superAdmin = false, fallback = null }) {
  const { can, isSuperAdmin } = useAuth();
  const allowed = superAdmin ? isSuperAdmin : can(feature, action);
  return <>{allowed ? children : fallback}</>;
}

export default AuthorizedContent;
